import { Link } from "@tanstack/react-router";
import { contactLink } from "@/lib/analytics";
import logoAsset from "@/assets/logo-sylwia-sitkowska.webp";

const OFFER_LINKS = [
  { to: "/wystapienia", label: "Wystąpienia i współpraca" },
  { to: "/mastermind", label: "Mastermind dla liderów" },
  { to: "/konsultacje", label: "Konsultacje indywidualne" },
  { to: "/rezerwacja", label: "Rezerwacja spotkania" },
] as const;

const KNOWLEDGE_LINKS = [
  { to: "/test-na-wypalenie-zawodowe", label: "Test na wypalenie zawodowe" },
  { to: "/wypalenie-zawodowe-u-lidera", label: "Wypalenie zawodowe: objawy" },
  { to: "/psychologia-biznesu", label: "Psychologia biznesu" },
  { to: "/syndrom-oszusta", label: "Syndrom oszusta" },
  { to: "/perfekcjonizm", label: "Perfekcjonizm" },
  { to: "/stres-w-pracy-a-decyzje", label: "Stres a decyzje" },
  { to: "/samotnosc-lidera", label: "Samotność lidera" },
  { to: "/mastermind-dla-przedsiebiorcow", label: "Mastermind dla przedsiębiorców" },
  { to: "/delegowanie-zadan", label: "Delegowanie zadań" },
] as const;

const ABOUT_LINKS = [
  { to: "/o-mnie", label: "O mnie" },
  { to: "/media-i-publikacje", label: "Media i publikacje" },
  { to: "/kontakt", label: "Kontakt" },
] as const;

function LinkColumn({
  title,
  links,
}: {
  title: string;
  links: readonly { to: string; label: string }[];
}) {
  return (
    <div>
      <p className="text-xs uppercase tracking-[0.18em] text-mist/60">{title}</p>
      <ul className="mt-4 space-y-2 text-sm text-mist/85">
        {links.map((link) => (
          <li key={link.to}>
            <Link to={link.to} className="inline-flex py-1 hover:text-mist hover:underline">
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function SiteFooter() {
  return (
    <footer className="grain bg-ink text-mist">
      <div className="container-page grid gap-10 py-16 md:grid-cols-3">
        <div>
          <Link
            to="/"
            aria-label="Sylwia Sitkowska, strona główna"
            className="inline-flex bg-mist p-2"
          >
            <img
              src={logoAsset}
              alt="Sylwia Sitkowska"
              width={300}
              height={159}
              className="h-12 w-auto"
              loading="lazy"
            />
          </Link>
          <p className="mt-4 text-sm text-mist/80">
            Psycholog · Psychoterapeutka · Przedsiębiorczyni
          </p>
          <address className="mt-4 text-xs not-italic leading-relaxed text-mist/70">
            PsychoLogika
            <br />
            NIP 1131986700
          </address>
        </div>

        <div className="text-sm">
          <a
            href="mailto:kontakt@sylwiasitkowska.pl"
            {...contactLink("footer")}
            className="inline-flex min-h-11 items-center border-b border-mist/30 pb-1 hover:border-mist"
          >
            kontakt@sylwiasitkowska.pl
          </a>
          <div className="mt-5 flex gap-5 text-xs uppercase tracking-[0.14em] text-mist/80">
            <a href="https://www.instagram.com/sitkowska.psycholog/" target="_blank" rel="noopener noreferrer" aria-label="Instagram Sylwii Sitkowskiej (otwiera się w nowej karcie)" className="inline-flex min-h-11 items-center hover:text-mist">
              Instagram
            </a>
            <a href="https://pl.linkedin.com/in/sylwia-sitkowska" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn Sylwii Sitkowskiej (otwiera się w nowej karcie)" className="inline-flex min-h-11 items-center hover:text-mist">
              LinkedIn
            </a>

          </div>
        </div>
        <div className="flex flex-col gap-3 text-xs uppercase tracking-[0.14em] text-mist/80 md:items-end">
          <Link to="/sitemap" className="inline-flex min-h-11 items-center hover:text-mist">
            Mapa strony
          </Link>
          <Link
            to="/polityka-prywatnosci"
            className="inline-flex min-h-11 items-center hover:text-mist"
          >
            Polityka prywatności

          </Link>
        </div>
      </div>

      <nav
        aria-label="Nawigacja w stopce"
        className="container-page grid gap-10 border-t border-mist/15 py-12 sm:grid-cols-2 lg:grid-cols-3"
      >
        <LinkColumn title="Praca ze mną" links={OFFER_LINKS} />
        <LinkColumn title="Psychologia biznesu" links={KNOWLEDGE_LINKS} />
        <LinkColumn title="O mnie" links={ABOUT_LINKS} />
      </nav>

      <div className="border-t border-mist/15 py-6 text-center text-xs uppercase tracking-[0.16em] text-mist/70">
        © {new Date().getFullYear()} Sylwia Sitkowska
      </div>
    </footer>
  );
}
